import { combineReducers } from 'redux';

import { applicationReducer } from './application';
import { cardsReducer } from './cards';
import { consentReducer } from './consent';
import { contextReducer } from './context';
import { errorReducer } from './error';
import { featureReducer } from './feature';
import { kdkReducer } from './kdk';
import { lbsReducer } from './lbs';
import { loaderReducer } from './loader';
import { nafReducer } from './naf';
import { sblReducer } from './sbl';
import { signingReducer } from './signing';
import { stepsReducer } from './steps';
import { userReducer } from './user';

export const rootReducer = combineReducers({
    application: applicationReducer,
    context: contextReducer,
    signing: signingReducer,
    consent: consentReducer,
    loader: loaderReducer,
    error: errorReducer,
    steps: stepsReducer,
    cards: cardsReducer,
    user: userReducer,
    kdk: kdkReducer,
    naf: nafReducer,
    lbs: lbsReducer,
    sbl: sblReducer,
    feature: featureReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default { rootReducer };
